import { render, staticRenderFns } from "./TenantsFilter.vue?vue&type=template&id=2f36dac6"
import script from "./TenantsFilter.vue.ts?vue&type=script&lang=ts&external"
export * from "./TenantsFilter.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports